import React from 'react';
import GoogleTagManager from 'gtm'

import SelectedRegionController from 'modules/Controllers/SelectedRegion/SelectedRegionController'
import IndicatorEvolutionContainer from 'modules/Content/IndicatorEvolutionContainer'

class IndicatorEvolutionEmbedPage extends React.Component {
  
  // constructor( props ) {
  //   super( props );
  // }

  render() {
    const searchParams = new URLSearchParams(this.props.location.search);
    // timeperiod
    let timePeriodStart = parseInt(searchParams.get("timeperiod.start"), 10);
    let timePeriodEnd = parseInt(searchParams.get("timeperiod.end"), 10);
    let timePeriodLength = parseInt(searchParams.get("timeperiod.length"), 10);
    // regions
    let geoIds = searchParams.getAll("geo.id").map((v) => parseInt(v, 10) );
    let geoStyles = searchParams.getAll("geo.style");
    let regionsToPlot = geoIds.map( (geoId, i) => {
      return {
        id: geoId,
        style: geoStyles.at( i )
      }
    } );

  console.log(regionsToPlot);
    return (
      <div className="App">
        <GoogleTagManager gtmId="GTM-NXH8F9G" />
        <SelectedRegionController />
        <IndicatorEvolutionContainer  embed={true} 
                                      timePeriodStart={timePeriodStart}
                                      timePeriodEnd={timePeriodEnd}
                                      timePeriodLength={timePeriodLength}
                                      geoIds={geoIds}
                                      regionsToPlot={regionsToPlot}/>
      </div>
    )
  }
}

export default IndicatorEvolutionEmbedPage;



// WEBPACK FOOTER //
// ./src/pages/IndicatorEvolutionEmbedPage/IndicatorEvolutionEmbedPage.jsx